import React from 'react';
import _ from 'lodash';
import {
    InformationTitle,
    InformationDescription,
    InformationName,
    InformationWrapper
} from '../../CampaignDetails.styles';
import { FlexWrapper, StyledMapContainer } from './Locations.styles';
import { LocationsProps } from './Locations.interface';
import { TileLayer, Marker, Circle } from 'react-leaflet';
import { latLngBounds } from 'leaflet';

export function Locations({ locations, specialities }: LocationsProps) {
    let bigPadding = true;
    const bounds = latLngBounds([]);
    
    if (locations) {
        const minLat = _.minBy(locations, (loc) => loc.lat);
        const minLng = _.minBy(locations, (loc) => loc.lng);
        const maxLat = _.maxBy(locations, (loc) => loc.lat);
        const maxLng = _.maxBy(locations, (loc) => loc.lng);
        if (maxLat && maxLng && minLat && minLng) {
            if (maxLng.lng - minLng.lng > 20 || maxLat.lat - minLat.lat > 20) {
                bigPadding = false
            }
        }
        locations.map((data) => {
            bounds.extend([data.lat, data.lng])
        })
    }
    return (
        <div>
            <InformationTitle>Locations</InformationTitle>
            <InformationWrapper>
                {locations.length > 0 ?
                    <>
                        <StyledMapContainer bounds={bounds} maxZoom={5} boundsOptions={{padding: [bigPadding ? 100 : 20, bigPadding ? 100 : 20]}} >
                            <TileLayer
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            {locations.map((each: any) => (
                                <Marker key={each.id} position={[each.lat, each.lng]}>
                                    <Circle 
                                        center={[each.lat, each.lng]}
                                        radius={322000}
                                        fillOpacity={0.5}
                                        fillColor="#2a71d48f"
                                    />
                                </Marker>
                            ))}
                        </StyledMapContainer>
                        <InformationName>Specialties</InformationName>
                        {(specialities && specialities.length > 0) ?
                            <>
                                {specialities.map((each: any) => (
                                    <InformationDescription key={each.id}>{each.name}</InformationDescription>
                                ))}
                            </>
                            : <InformationDescription>All</InformationDescription>
                        }
                    </>
                    :
                    <FlexWrapper>
                        <div>
                            <InformationName>Locations</InformationName> 
                            <InformationDescription>Globally</InformationDescription>
                        </div>
                        <div>
                        <InformationName>Specialties</InformationName>
                        {(specialities && specialities.length > 0) ?
                            <>
                                {specialities.map((each: any) => (
                                    <InformationDescription key={each.id}>{each.name}</InformationDescription>
                                ))}
                            </>
                                : <InformationDescription>All</InformationDescription>
                            }
                        </div>
                    </FlexWrapper>
                }
            </InformationWrapper>
        </div>
    )
}
